/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { DiagnoseSurveyCto } from '../../models/diagnose-survey-cto';

export interface GetSurveysByCompanyIdAsync$Plain$Params {
  companyId: number;
  includeClosed?: boolean;
}

export function getSurveysByCompanyIdAsync$Plain(http: HttpClient, rootUrl: string, params: GetSurveysByCompanyIdAsync$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<DiagnoseSurveyCto>>> {
  const rb = new RequestBuilder(rootUrl, getSurveysByCompanyIdAsync$Plain.PATH, 'get');
  if (params) {
    rb.path('companyId', params.companyId, {});
    rb.query('includeClosed', params.includeClosed, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<DiagnoseSurveyCto>>;
    })
  );
}

getSurveysByCompanyIdAsync$Plain.PATH = '/diagnose/xp-survey-actions/company-id/{companyId}/surveys';
